module.exports = {
  EVENT: 'e',
  APPOINTMENT: 'a'
}
